import { QueryParams } from 'common/urls/QueryParams';
import { UseDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { match } from 'ts-pattern';
import {
  BrowseByTagsDietaryTags,
  BrowseByTagsFilterTags,
  BrowseByTagsProteinTags,
  BrowseByTagsUrlFilters,
  ListOfBrowseByTagsFiltersTags,
} from './types';

export const generateFilters = (
  filters: UseDishFirstExploreUrl,
  queryParam: QueryParams,
  tag: BrowseByTagsFilterTags
): BrowseByTagsUrlFilters => {
  const filteredDietary = filters.dietaryFilters.filter((f) => !ListOfBrowseByTagsFiltersTags.includes(f));
  const filteredProtein = filters.proteinFilters.filter((f) => !ListOfBrowseByTagsFiltersTags.includes(f));
  return match(queryParam)
    .with(QueryParams.DIETARY_FILTER, () => {
      const dietaryTag = tag as BrowseByTagsDietaryTags;
      return {
        [QueryParams.DIETARY_FILTER]: filteredDietary.concat([dietaryTag]),
        [QueryParams.PROTEIN_FILTER]: filteredProtein,
      };
    })
    .with(QueryParams.PROTEIN_FILTER, () => {
      const proteinTag = tag as BrowseByTagsProteinTags;
      return {
        [QueryParams.DIETARY_FILTER]: filteredDietary,
        [QueryParams.PROTEIN_FILTER]: filteredProtein.concat([proteinTag]),
      };
    })
    .otherwise(() => ({
      [QueryParams.DIETARY_FILTER]: filteredDietary,
      [QueryParams.PROTEIN_FILTER]: filteredProtein,
    }));
};
